import {useMutation} from '@tanstack/react-query';
import creatorsUpdaters from '@/api/updaters/creators';
import type {StartConversationResponse} from '@/api/updaters/creators';

function useStartConversation() {
  return useMutation<
    StartConversationResponse,
    Error,
    {brandId: string; creatorId: string; initialMessage: string}
  >({
    mutationKey: ['creators', 'startConversation'],
    mutationFn: creatorsUpdaters.startConversation,
  });
}

export default useStartConversation;
